import React, { Component } from 'react';
import { Modal } from 'office-ui-fabric-react';
import "./styles.scss";

class ModalGE extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: true }
  }
  handleClose = () => {
    this.setState(() => {
      return { visible: false };
    });
    this.props.onDismiss();
  };

  render() {
    const {
      children,
      isOpen = true,
      isBlocking = true,
      showCrossButton = true,
      onDismiss = () => {
        this.handleClose()
      }
    } = this.props;
    return (
      <>
        {this.state.visible &&
          <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={isBlocking}
          >
            <div className="modal-data-wrapper">
            {showCrossButton && (
              <div className="cross-button"> 
              <div onClick={() => this.handleClose()}> + </div>
              </div>)}
              {children}
            </div>
          </Modal>
        }
      </>
    );
  }
}

export default ModalGE;
